export default {
  data: () => ({
    component: '',
    catchError: null,
  }),
  computed: {
    env() {
      return process.env.NODE_ENV;
    },
  },
  methods: {
    async load() {
      if (!this.comp) {
        this.component = '';
        return;
      }

      // if the component has a env defined only show in that env
      if (this.comp.mode && this.comp.env !== this.env) {
        this.component = '';
        return;
      }

      try {
        // eslint-disable-next-line
        const file = await this.comp.path();
        this.component = file.default;
      } catch (err) {
        this.component = '';
        this.catchError = err;
      }
    },
  },
};
